import {
  GET_SAVED_REPORTS,
  GET_SAVED_REPORTS_SUCCESS,
  GET_SAVED_REPORTS_FAILURE,
  SAVE_REPORT,
  SAVE_REPORT_SUCCESS,
  SAVE_REPORT_FAILURE,
  DELETE_SAVED_REPORT,
  DELETE_SAVED_REPORT_SUCCESS,
  DELETE_SAVED_REPORT_FAILURE,
} from './actionType';

export const getSavedReports = () => ({
  type: GET_SAVED_REPORTS,
});

export const getSavedReportsSuccess = (payload) => ({
  type: GET_SAVED_REPORTS_SUCCESS,
  payload,
});

export const getSavedReportsFailure = (payload) => ({
  type: GET_SAVED_REPORTS_FAILURE,
  payload,
});

export const saveReport = (payload) => ({
  type: SAVE_REPORT,
  payload,
});

export const saveReportSuccess = (payload) => ({
  type: SAVE_REPORT_SUCCESS,
  payload,
});

export const saveReportFailure = (payload) => ({
  type: SAVE_REPORT_FAILURE,
  payload,
});

export const deleteSavedReport = (payload) => ({
  type: DELETE_SAVED_REPORT,
  payload,
});

export const deleteSavedReportSuccess = (payload) => ({
  type: DELETE_SAVED_REPORT_SUCCESS,
  payload,
});

export const deleteSavedReportFailure = (payload) => ({
  type: DELETE_SAVED_REPORT_FAILURE,
  payload,
});
